* {
  box-sizing: border-box;
}

:host {
  display: none;
}

@media (min-width: 1025px) {
  :host {
    position: absolute;
    display: block;
    cursor: pointer;
  }
}

.overlay {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
  position: relative;
  pointer-events: none;
}

:host([data-active='true']) .overlay {
  position: absolute;
  z-index: 100;
  opacity: 1;
  overflow: visible;
  pointer-events: initial;
}

.overlay > *:not(.close-button) {
  position: absolute;
}

.popup {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.close-button {
  position: absolute;
  right: 0;
  z-index: 2;
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  margin-right: 0;
  margin-left: auto;
  border: 1px solid rgba(255,255,255,0.5);
  border-top-right-radius: 6px;
  outline: 0;
  color: var(--cwc-color-white, #fff);
  background-color: var(--cwc-color-red, #ff3232);
  cursor: pointer;
}

.close-button svg path {
  fill: var(--cwc-color-white, #fff);
}

/* positioning classes */

.top-left {
  top: 0;
  left: 0;
}

.top-right {
  top: 0;
  right: 0;
}

.bottom-left {
  bottom: 0;
  left: 0;
}

.bottom-right {
  bottom: 0;
  right: 0;
}
